// import React, { useState, useEffect } from "react";
// import {
//   Row,
//   Col,
// } from "react-bootstrap";

// import "bootstrap/dist/css/bootstrap.min.css";
// import "../../assets/css/style.css";
// import FilterSection from "./FilterSection";
// import SortingSection from "./SortingSection";
// import TourCard from "./TourCard ";
// import BASE_URL from "../../component/commanfile";
// import axios from "axios";

// function TourPackeges({ tourSectorDetails, id }) {
// const [activeType, setActiveType] = useState("all"); 
// // all | tour | fit
//   const [tours, setTours] = useState([]);
//   const [filteredTours, setFilteredTours] = useState([]);
//   const [viewMode, setViewMode] = useState("grid");
//   const [sortOption, setSortOption] = useState("deals");
//   const [selectedPriceRange, setSelectedPriceRange] = useState(null);

//   const [filters, setFilters] = useState({
//     priceRange: null,
//     duration: null,
//     departureDates: null,
//     cities: [],
//     packageTypes: [],
//     specialties: [],
//   });

//   // -----------------------------
//   // Fetch tours based on type
//   // -----------------------------
//  useEffect(() => {
//   const fetchData = async () => {
//     let tourData = [];
//     let fitData = [];

//     // TOUR data
//     if (Array.isArray(tourSectorDetails?.tour_package)) {
//       tourData = tourSectorDetails.tour_package.map(t => ({
//         ...t,
//         __type: "tour",   // 🔥 identify type
//       }));
//     }

//     // FIT data
//     if (activeType === "fit" || activeType === "all") {
//       try {
//         const response = await axios.get(
//           `${BASE_URL}api/web-tours/web-fit-sectors-package/${id}`
//         );

//         fitData = Array.isArray(response?.data?.tour_package)
//           ? response.data.tour_package.map(f => ({
//               ...f,
//               __type: "fit", // 🔥 identify type
//             }))
//           : [];
//       } catch (err) {
//         console.error("FIT fetch error", err);
//       }
//     }

//     if (activeType === "tour") {
//       setTours(tourData);
//       setFilteredTours(tourData);
//     }

//     if (activeType === "fit") {
//       setTours(fitData);
//       setFilteredTours(fitData);
//     }

//     if (activeType === "all") {
//       const combined = [...tourData, ...fitData];
//       setTours(combined);
//       setFilteredTours(combined);

//       console.log("testttttt===",combined)
//     }
//   };

//   fetchData();
// }, [activeType, id, tourSectorDetails]);

//   // -----------------------------
//   // Reset filters on type change
//   // -----------------------------
//   useEffect(() => {
//     setFilters({
//       priceRange: null,
//       duration: null,
//       departureDates: null,
//       cities: [],
//       packageTypes: [],
//       specialties: [],
//     });
//     setSelectedPriceRange(null);
//   }, [activeType]);

//   // -----------------------------
//   // Apply filters & sorting
//   // -----------------------------
//   useEffect(() => {
//     if (!Array.isArray(tours)) return;

//     let result = [...tours];

// //     if ( activeType === "tour" && filters?.priceRange) {
// //       result = result.filter((tour) =>
// //         Number(tour.doubleOccupancy) >= filters.priceRange.min &&
// //         Number(tour.doubleOccupancy) <= filters.priceRange.max
// //       );
// //     }

// // if (activeType === "fit" && filters?.priceRange) {
// //   result = result.filter((tour) => {
// //     let lowestPrice = Infinity;

// //     if (Array.isArray(tour.forfit)) {
// //       tour.forfit.forEach(config => {
// //         if (Array.isArray(config.seatConfigurationRate)) {
// //           config.seatConfigurationRate.forEach(rate => {
// //             const price = Number(rate.price);
// //             if (!isNaN(price) && price < lowestPrice) {
// //               lowestPrice = price;
// //             }
// //           });
// //         }
// //       });
// //     }

// //     if (lowestPrice === Infinity) return false;

// //     return (
// //       lowestPrice >= filters.priceRange.min &&
// //       lowestPrice <= filters.priceRange.max
// //     );
// //   });
// // }

// if (filters?.priceRange) {
//   result = result.filter((tour) => {
//     if (tour.__type === "tour") {
//       const price = Number(tour.doubleOccupancy || tour.price);
//       return price >= filters.priceRange.min &&
//              price <= filters.priceRange.max;
//     }

//     if (tour.__type === "fit") {
//       let lowest = Infinity;

//       tour.forfit?.forEach(f =>
//         f.seatConfigurationRate?.forEach(r => {
//           const p = Number(r.price);
//           if (!isNaN(p) && p < lowest) lowest = p;
//         })
//       );

//       return lowest !== Infinity &&
//              lowest >= filters.priceRange.min &&
//              lowest <= filters.priceRange.max;
//     }

//     return false;
//   });
// }



//     if (filters?.duration) {
//   result = result.filter(tour => {
//     if (tour.__type === "tour") {
//       return (
//         tour.duration >= filters.duration.min &&
//         tour.duration <= filters.duration.max
//       );
//     }

//     if (tour.__type === "fit") {
//       const days = tour.tour_itineraries?.length || 0;
//       return (
//         days >= filters.duration.min &&
//         days <= filters.duration.max
//       );
//     }

//     return false;
//   });
// }

//     if (filters.packageTypes?.length > 0) {
//       if (!filters.packageTypes.includes("All")) {
//         result = result.filter((tour) =>
//           tour.categoryList?.some((cat) => filters.packageTypes.includes(cat.name))
//         );
//       }
//     }
//     // Sorting
//     switch (sortOption) {
//       case "price-high":
//         result.sort((a, b) => Number(b.price) - Number(a.price));
//         break;
//       case "price-low":
//         result.sort((a, b) => Number(a.price) - Number(b.price));
//         break;
//       case "duration-long":
//         result.sort((a, b) => b.duration - a.duration);
//         break;
//       case "duration-short":
//         result.sort((a, b) => a.duration - b.duration);
//         break;
//       default:
//         break;
//     }

//     setFilteredTours(result);
//   }, [tours, filters, sortOption]);

//   // -----------------------------
//   // Handle filter changes
//   // -----------------------------
//   const handleFilterChange = (filterType, value) => {
//     setFilters((prev) => ({ ...prev, [filterType]: value }));
//     console.log("test-------", { [filterType]: value })
//   };
//   const clearFilters = () => {
//     setFilters({
//       priceRange: null,
//       duration: null,
//       departureDates: null,
//       cities: [],
//       packageTypes: [],
//       specialties: [],
//     });
//     setSelectedPriceRange(null);
//   };

//   // -----------------------------
//   // Render
//   // -----------------------------
//   console.log("test0000", tourSectorDetails, tours)

// const getPriceRangeFromTours = (tours = []) => {
//   if (!Array.isArray(tours) || tours.length === 0) return [];

//   const prices = [];

//   tours.forEach(tour => {
//     // 👉 TOUR case
//     if (tour.doubleOccupancy || tour.price) {
//       const p = Number(tour.doubleOccupancy || tour.price);
//       if (!isNaN(p)) prices.push(p);
//     }

//     // 👉 FIT case (seatConfigurationRate)
//     if (Array.isArray(tour.forfit)) {
//       tour.forfit.forEach(config => {
//         if (Array.isArray(config.seatConfigurationRate)) {
//           config.seatConfigurationRate.forEach(rate => {
//             const seatPrice = Number(rate.price);
//             if (!isNaN(seatPrice)) {
//               prices.push(seatPrice);
//             }
//           });
//         }
//       });
//     }
//   });

//   if (prices.length === 0) return [];

//   return [{
//     min: Math.min(...prices),
//     max: Math.max(...prices),
//   }];
// };

//   return (
//     <section id="tour-section" className="py-5">
//   <div style={{
//     padding:"0px 80px"
//   }}>

//         <h1 className="mb-2 section-title" style={{ color: "#0a3b78", fontWeight: "700", fontSize: "42px" }}>
//           {tours?.[0]?.tour_sector_name || ""}
//           Tour Packages
//           <p className="subtitle mb-4 fs-5" style={{ fontSize: "18px", fontWeight: "400" }}>
//             Explore {filteredTours.length} packages for your dream vacation
//           </p>
//         </h1>

//         <Row>
//           <Col lg={2} md={4} className="mb-4">
//             {/* <FilterSection
//               filters={filters}
//               onFilterChange={handleFilterChange}
//               onClearFilters={clearFilters}
//               selectedPriceRange={selectedPriceRange}
//               setSelectedPriceRange={setSelectedPriceRange}
//               tourSectorDetails={{
//                 tour_package: tours,
//                 tour_package_type: activeType == "tour"
//                   ? tourSectorDetails?.tour_package_type
//                   : tourSectorDetails?.tour_package_type,
//                 tour_duration: activeType === "tour"
//                   ? tourSectorDetails?.tour_duration
//                   : tours.map(t => ({ no_days: t.tour_itineraries?.length || 0 })),

//     tour_price:
//       activeType === "tour"
//         ? tourSectorDetails?.tour_price
//         : getPriceRangeFromTours(tours),
//               }}
//             /> */}

//             <FilterSection
//   filters={filters}
//   onFilterChange={handleFilterChange}
//   onClearFilters={clearFilters}
//   selectedPriceRange={selectedPriceRange}
//   setSelectedPriceRange={setSelectedPriceRange}
//   tourSectorDetails={{
//     tour_package: activeType === "all"
//       ? [...(tourSectorDetails?.tour_package || []), ...(tours || [])]  // Fallback to empty arrays if undefined or null
//       : tours,
//     tour_package_type: tourSectorDetails?.tour_package_type,
//     tour_duration: activeType === "all"
//       ? [
//           ...(tourSectorDetails?.tour_duration || []),
//           ...tours.map(t => ({ no_days: t.tour_itineraries?.length || 0 }))
//         ]
//       : tours.map(t => ({ no_days: t.tour_itineraries?.length || 0 })),
//     tour_price: activeType === "all"
//       ? getPriceRangeFromTours([
//           ...(tourSectorDetails?.tour_package || []), 
//           ...(tours || [])
//         ])
//       : getPriceRangeFromTours(tours),
//   }}
// />

//           </Col>

//           <Col lg={10} md={8}>
//             <SortingSection
//               viewMode={viewMode}
//               setViewMode={setViewMode}
//               sortOption={sortOption}
//               setSortOption={setSortOption}
//               activeType={activeType}
//               setActiveType={setActiveType}
//             />

//             <Row className={viewMode === "grid" ? "grid-view" : "list-view"} id="tourPackages">
//               {filteredTours.map((tour) => (
//                 <Col key={tour.id} md={viewMode === "grid" ? 3 : 12} className="tour-card-col mb-4">
//                   <TourCard tour={tour} viewMode={viewMode} activeType={activeType} />
//                 </Col>
//               ))}
//             </Row>
//           </Col>
//         </Row>
//       </div>
//     </section>
//   );
// }

// export default TourPackeges;


// import React, { useState, useEffect } from "react";
// import { Row, Col, Offcanvas } from "react-bootstrap";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "../../assets/css/style.css";
// import FilterSection from "./FilterSection";
// import SortingSection from "./SortingSection";
// import TourCard from "./TourCard ";
// import BASE_URL from "../../component/commanfile";
// import axios from "axios";

// function TourPackeges({ tourSectorDetails, id , data, setData ,setHeroThumbnail ,setHero  }) {
//   const [activeType, setActiveType] = useState("all"); // all | tour | fit
//   const [tours, setTours] = useState([]);
//   const [filteredTours, setFilteredTours] = useState([]);
//   const [viewMode, setViewMode] = useState("grid");
//   const [sortOption, setSortOption] = useState("deals");
//   const [selectedPriceRange, setSelectedPriceRange] = useState(null);
// const [filterDrawerOpen, setFilterDrawerOpen] = useState(false);
//   const [filters, setFilters] = useState({
//     priceRange: null,
//     duration: null,
//     departureDates: null,
//     cities: [],
//     packageTypes: [],
//     specialties: [],
//   });

//   // -----------------------------
//   // Fetch tours based on type
//   // -----------------------------
//   useEffect(() => {

//     // setLoading(true)
//     const fetchData = async () => {
//       let tourData = [];
//       let fitData = [];

//       // TOUR data
//       if (Array.isArray(tourSectorDetails?.tour_package)) {
//         tourData = tourSectorDetails.tour_package.map((t) => ({
//           ...t,
//           __type: "tour", // 🔥 identify type
//         }));
//       }

//       // FIT data
//       if (activeType === "fit" || activeType === "all") {
//         try {
//           const response = await axios.get(
//             `${BASE_URL}api/web-tours/web-fit-sectors-package/${id}`
//           );

//           fitData = Array.isArray(response?.data?.tour_package)
//             ? response.data.tour_package.map((f) => ({
//               ...f,
//               __type: "fit", // 🔥 identify type
//             }))
//             : [];
//         } catch (err) {
//           console.error("FIT fetch error", err);
//         }
//       }

//       // Combine tour and fit data when activeType is "all"
//       if (activeType === "tour") {
//         setTours(tourData);
//         setFilteredTours(tourData);
//         setData(tourData);
//                 setHeroThumbnail(tourData[0]?.thumbnail || "");
//                 setHero(tourData[0] || {});
//       }

//       if (activeType === "fit") {
//         setTours(fitData);
//         setFilteredTours(fitData);
//         setData(fitData);
//                 setHeroThumbnail(fitData[0]?.thumbnail || "");
//                 setHero(fitData[0] || {});
//       }

  

//          if (activeType === "all") {
//   const combined = [
//     ...tourData.map(t => ({
//       ...t,
//       __type: "tour",
//       priority: t.priority ?? 999
//     })),
//     ...fitData.map(f => ({
//       ...f,
//       __type: "fit",
//       priority: f.priority ?? 999
//     })),
//   ];

//   combined.sort((a, b) => {
//     if (a.priority !== b.priority) {
//       return a.priority - b.priority;
//     }
//     return new Date(b.created_at) - new Date(a.created_at);
//   });

//   console.log("test===>123213213",combined)
//   setTours(combined);
//   setFilteredTours(combined);
//   setData(combined);
//       setHeroThumbnail(combined[0].thumbnail);
//                 setHero(combined[0]);
// }
//     };

//     fetchData();
//   }, [activeType, id, tourSectorDetails]);


//   useEffect(() => {
//     setFilters({
//       priceRange: null,
//       duration: null,
//       departureDates: null,
//       cities: [],
//       packageTypes: [],
//       specialties: [],
//     });
//     setSelectedPriceRange(null);
//   }, [activeType]);


//   useEffect(() => {
//     if (!Array.isArray(tours)) return;

//     let result = [...tours];

//     // Apply price range filter
//     if (filters?.priceRange) {
//       result = result.filter((tour) => {
//         if (tour.__type === "tour") {
//           const price = Number(tour.doubleOccupancy || tour.price);
//           return price >= filters.priceRange.min && price <= filters.priceRange.max;
//         }

//         if (tour.__type === "fit") {
//           let lowest = Infinity;

//           tour.forfit?.forEach((f) =>
//             f.seatConfigurationRate?.forEach((r) => {
//               const p = Number(r.price);
//               if (!isNaN(p) && p < lowest) lowest = p;
//             })
//           );

//           return lowest !== Infinity && lowest >= filters.priceRange.min && lowest <= filters.priceRange.max;
//         }

//         return false;
//       });
//     }

//     // Apply duration filter
//     if (filters?.duration) {
//       result = result.filter((tour) => {
//         if (tour.__type === "tour") {
//           return (
//             tour.duration >= filters.duration.min && tour.duration <= filters.duration.max
//           );
//         }

//         if (tour.__type === "fit") {
//           const days = tour.tour_itineraries?.length || 0;
//           return days >= filters.duration.min && days <= filters.duration.max;
//         }

//         return false;
//       });
//     }

//  if (filters.cities?.length > 0) {
//     console.log("testttttt=", filters.cities, result);

//     result = result.filter((tour) => {
//         // Decide which itineraries to check
//               const itinerariesToCheck =
//             tour.__type === "tour"
//                 ? [tour.tour_itineraries?.[0]]   // ✅ fix here
//                 : tour.tour_itineraries || [];


//         // Get accommodations from the chosen itineraries
//         const accommodations = itinerariesToCheck
//             ?.map((itinerary) => itinerary.accommodation)
//             .filter((city) => city && city !== "—"); // ignore dashes

//         // Remove duplicates
//         const uniqueCities = [...new Set(accommodations)];

//         // Check if any of the cities match the filter
//         return uniqueCities.some((city) => filters.cities.includes(city));
//     });
// }

//     // Apply packageTypes filter
//     if (filters.packageTypes?.length > 0) {
//       if (!filters.packageTypes.includes("All")) {
//         result = result.filter((tour) =>
//           tour.categoryList?.some((cat) => filters.packageTypes.includes(cat.name))
//         );
//       }
//     }

    
//     // Sorting
//     switch (sortOption) {
//       case "price-high":
//         result.sort((a, b) => Number(b.price) - Number(a.price));
//         break;
//       case "price-low":
//         result.sort((a, b) => Number(a.price) - Number(b.price));
//         break;
//       case "duration-long":
//         result.sort((a, b) => b.duration - a.duration);
//         break;
//       case "duration-short":
//         result.sort((a, b) => a.duration - b.duration);
//         break;
//       default:
//         break;
//     }

//     setFilteredTours(result);
//   }, [tours, filters, sortOption]);

//   // -----------------------------
//   // Handle filter changes
//   // -----------------------------
//   const handleFilterChange = (filterType, value) => {
//     setFilters((prev) => ({ ...prev, [filterType]: value }));
//   };

//   const clearFilters = () => {
//     setFilters({
//       priceRange: null,
//       duration: null,
//       departureDates: null,
//       cities: [],
//       packageTypes: [],
//       specialties: [],
//     });
//     setSelectedPriceRange(null);
//   };


//   const getPriceRangeFromTours = (tours = []) => {
//     if (!Array.isArray(tours) || tours.length === 0) return []; 

//     const prices = [];

//     tours.forEach(tour => {
//       if (tour.type !== "fit" && tour.doubleOccupancy) {
//         const price = Number(tour.doubleOccupancy); 
//         if (!isNaN(price)) prices.push(price); 
//       }

//       if (tour.type === "fit" && Array.isArray(tour.forfit)) {
//         tour.forfit.forEach(config => {
//           if (Array.isArray(config.seatConfigurationRate)) {
//             config.seatConfigurationRate.forEach(rate => {
//               const price = Number(rate.price);
//               if (!isNaN(price)) prices.push(price); 
//             });
//           }
//         });
//       }
//     });

//     if (prices.length === 0) return []; 

//     prices.sort((a, b) => a - b);

//     const minPrice = prices[0];
//     const maxPrice = prices[prices.length - 1];

//     if (minPrice === maxPrice) {
//       return [{ min: 0, max: maxPrice }];
//     }

//     const priceRange = maxPrice - minPrice;
//     const bucketCount = Math.ceil(priceRange / 50000); 

//     const minBuckets = Math.max(bucketCount, 3);

//     const priceBuckets = [];

//     let currentMin = minPrice;
//     let bucketSize = Math.ceil(priceRange / minBuckets);

//     for (let i = 0; i < minBuckets; i++) {
//       const currentMax = Math.min(currentMin + bucketSize, maxPrice); 
//       priceBuckets.push({
//         min: currentMin,
//         max: currentMax
//       });
//       currentMin = currentMax + 1; 
//     }

//     console.log("Price Buckets:", priceBuckets);
//     return priceBuckets;
//   };


//   return (
//     <section id="tour-section" className="py-5">
//       <div className="con-tour-section" >
//         <h1
//           className="mb-2 section-title"
//           style={{ color: "#0a3b78", fontWeight: "700", fontSize: "42px" }}
//         >
//           {tours?.[0]?.tour_sector_name || ""}
//           Tour Packages
//           <p
//             className="subtitle mb-4 fs-5"
//             style={{ fontSize: "18px", fontWeight: "400" }}
//           >
//             Explore {filteredTours.length} packages for your dream vacation
//           </p>
//         </h1>
// <div
//   className="d-flex justify-content-between align-items-center mb-3 d-md-none"
//   style={{ padding: "0 1rem", gap: "0.75rem" }}
// >
  
//   <button
//     type="button"
//     onClick={() => setFilterDrawerOpen(true)}
//     className="btn btn-primary d-flex align-items-center"
//     style={{ gap: "0.5rem", fontWeight: "600" }}
//   >
//     <i className="bi bi-filter" style={{ fontSize: "1.2rem" }}></i>
//     Filters
//   </button>

//   <button
//     type="button"
//     onClick={clearFilters}
//     className="btn btn-outline-secondary"
//     style={{ fontWeight: "600" }}
//   >
//     Clear
//   </button>
// </div>
// <Offcanvas show={filterDrawerOpen} onHide={() => setFilterDrawerOpen(false)}
//  placement="start"
//     scroll={true}        // ✅ enables scroll if content is long
//   backdrop={true}      // optional, dark overlay  scroll={true}        // ✅ enables scroll if content is long
//   backdrop={true}      // optional, dark overlay
//   >
//   <Offcanvas.Header closeButton
//    style={{
//       backgroundColor: "#0a3b78",
//       color: "white",
//       padding: "1rem",
//       position: "relative",
//       paddingTop:"70px"
//     }}
//   >
//      <style>
//       {`
//         .btn-close {
//           filter: invert(1);
//           opacity: 1;
//         }
//       `}
//     </style>
//     <Offcanvas.Title>Filters</Offcanvas.Title>
//   </Offcanvas.Header>
//   <Offcanvas.Body>
//   <FilterSection
//               filters={filters}
//               onFilterChange={handleFilterChange}
//               onClearFilters={clearFilters}
//               selectedPriceRange={selectedPriceRange}
//               setSelectedPriceRange={setSelectedPriceRange}
//               activeType={activeType}
//               tourSectorDetails={{
//                 tour_package: activeType == "all"
//                   ? [...(tourSectorDetails?.tour_package || []), ...(tours || [])] 
//                   : tours,
//                 tour_package_type: tourSectorDetails?.tour_package_type,
//                 tour_duration: tourSectorDetails?.tour_duration,
//                 tour_package_type: tourSectorDetails?.tour_package_type,
//                 tour_duration: activeType === "all"
//                   ? [
//                     ...(Array.isArray(tourSectorDetails?.tour_duration)
//                       ? tourSectorDetails.tour_duration.flat()
//                       : []),
//                     ...tours.map(t => ({ no_days: t.tour_itineraries?.length || 0 }))
//                   ]
//                   : activeType != "fit"
//                     ? tours.map(t => ({ no_days: t.duration || 0 }))
//                     :tours.map(t => ({ no_days: t.tour_itineraries?.length || 0 }))
//                     ,

//                 tour_price:
//                   activeType === "all"
//                     ? getPriceRangeFromTours([
//                       ...(tourSectorDetails?.tour_package || []),
//                       ...(tours || []),
//                     ])
//                     : getPriceRangeFromTours(tours),
// cities: [
//   ...new Set(
//     (tours || []).flatMap((tour) => {
//       const itineraries = Array.isArray(tour?.tour_itineraries)
//         ? tour.tour_itineraries
//         : [];

//       return itineraries
//         .map((itinerary) =>
//           typeof itinerary?.accommodation === "string"
//             ? itinerary.accommodation.trim()
//             : null
//         )
//         .filter((city) => city && city !== "—");
//     })
//   ),
// ],
//               }}
//               getPriceRangeFromTours={getPriceRangeFromTours}
//             />
//   </Offcanvas.Body>
// </Offcanvas>
//         <Row>
//           <Col lg={2} md={4}  className="mb-4 d-none d-md-block">
//             <FilterSection
//               filters={filters}
//               onFilterChange={handleFilterChange}
//               onClearFilters={clearFilters}
//               selectedPriceRange={selectedPriceRange}
//               setSelectedPriceRange={setSelectedPriceRange}
//               activeType={activeType}
//               tourSectorDetails={{
//                 tour_package: activeType == "all"
//                   ? [...(tourSectorDetails?.tour_package || []), ...(tours || [])] 
//                   : tours,
//                 tour_package_type: tourSectorDetails?.tour_package_type,
//                 tour_duration: tourSectorDetails?.tour_duration,
//                 tour_package_type: tourSectorDetails?.tour_package_type,
//                 tour_duration: activeType === "all"
//                   ? [
//                     ...(Array.isArray(tourSectorDetails?.tour_duration)
//                       ? tourSectorDetails.tour_duration.flat()
//                       : []),
//                     ...tours.map(t => ({ no_days: t.tour_itineraries?.length || 0 }))
//                   ]
//                   : activeType != "fit"
//                     ? tours.map(t => ({ no_days: t.duration || 0 }))
//                     :tours.map(t => ({ no_days: t.tour_itineraries?.length || 0 }))
//                     ,

//                 tour_price:
//                   activeType === "all"
//                     ? getPriceRangeFromTours([
//                       ...(tourSectorDetails?.tour_package || []),
//                       ...(tours || []),
//                     ])
//                     : getPriceRangeFromTours(tours),
// cities: [
//   ...new Set(
//     (tours || []).flatMap((tour) => {
//       const itineraries = Array.isArray(tour?.tour_itineraries)
//         ? tour.tour_itineraries
//         : [];

//       return itineraries
//         .map((itinerary) =>
//           typeof itinerary?.accommodation === "string"
//             ? itinerary.accommodation.trim()
//             : null
//         )
//         .filter((city) => city && city !== "—");
//     })
//   ),
// ],
//               }}
//               getPriceRangeFromTours={getPriceRangeFromTours}
//             />
//           </Col>

//           <Col lg={10} md={8}>
//             <SortingSection
//               viewMode={viewMode}
//               setViewMode={setViewMode}
//               sortOption={sortOption}
//               setSortOption={setSortOption}
//               activeType={activeType}
//               setActiveType={setActiveType}
//             />

//             <Row className={viewMode === "grid" ? "grid-view" : "list-view"} id="tourPackages">
//               {filteredTours.map((tour) => (
//                 <Col key={tour.id} md={viewMode === "grid" ? 3 : 12} className="tour-card-col mb-4">
//                   <TourCard tour={tour} viewMode={viewMode} activeType={activeType} />
//                 </Col>
//               ))}
//             </Row>
//           </Col>
//         </Row>
//       </div>
//     </section>
//   );
// }

// export default TourPackeges;





// import React, { useState, useEffect, useCallback, useMemo } from "react";
// import { Row, Col, Offcanvas } from "react-bootstrap";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "../../assets/css/style.css";
// import FilterSection from "./FilterSection";
// import SortingSection from "./SortingSection";
// import TourCard from "./TourCard ";
// import BASE_URL from "../../component/commanfile";
// import axios from "axios";

// // ---------------------------------------------------------------------------
// // Pure helper — defined OUTSIDE component so it is never recreated
// // ---------------------------------------------------------------------------
// const getPriceRangeFromTours = (tours = []) => {
//   if (!Array.isArray(tours) || tours.length === 0) return [];

//   const prices = [];

//   tours.forEach((tour) => {
//     if (tour.__type !== "fit" && tour.doubleOccupancy) {
//       const price = Number(tour.doubleOccupancy);
//       if (!isNaN(price)) prices.push(price);
//     }

//     if (tour.__type === "fit" && Array.isArray(tour.forfit)) {
//       tour.forfit.forEach((config) => {
//         config.seatConfigurationRate?.forEach((rate) => {
//           const price = Number(rate.price);
//           if (!isNaN(price)) prices.push(price);
//         });
//       });
//     }
//   });

//   if (prices.length === 0) return [];
//   prices.sort((a, b) => a - b);

//   const minPrice = prices[0];
//   const maxPrice = prices[prices.length - 1];
//   if (minPrice === maxPrice) return [{ min: 0, max: maxPrice }];

//   const priceRange = maxPrice - minPrice;
//   const bucketCount = Math.max(Math.ceil(priceRange / 50000), 3);
//   const bucketSize = Math.ceil(priceRange / bucketCount);
//   const buckets = [];

//   let currentMin = minPrice;
//   for (let i = 0; i < bucketCount; i++) {
//     const currentMax = Math.min(currentMin + bucketSize, maxPrice);
//     buckets.push({ min: currentMin, max: currentMax });
//     currentMin = currentMax + 1;
//   }

//   return buckets;
// };

// // ---------------------------------------------------------------------------
// // Initial filter state — extracted so it can be reused without object churn
// // ---------------------------------------------------------------------------
// const INITIAL_FILTERS = {
//   priceRange: null,
//   duration: null,
//   departureDates: null,
//   cities: [],
//   packageTypes: [],
//   specialties: [],
// };

// // ---------------------------------------------------------------------------
// // Component
// // ---------------------------------------------------------------------------
// function TourPackeges({
//   tourSectorDetails,
//   id,
//   data,
//   setData,
//   setHeroThumbnail,
//   setHero,
// }) {
//   const [activeType, setActiveType] = useState("all");
//   const [tours, setTours] = useState([]);
//   const [filteredTours, setFilteredTours] = useState([]);
//   const [viewMode, setViewMode] = useState("grid");
//   const [sortOption, setSortOption] = useState("deals");
//   const [selectedPriceRange, setSelectedPriceRange] = useState(null);
//   const [filterDrawerOpen, setFilterDrawerOpen] = useState(false);
//   const [filters, setFilters] = useState(INITIAL_FILTERS);
// console.log("tour_package_type-----",tourSectorDetails.tour_package_type)
//   // -------------------------------------------------------------------------
//   // Fetch tours — runs only when activeType, id, or tourSectorDetails changes
//   // -------------------------------------------------------------------------
//   useEffect(() => {
//     let cancelled = false;

//     const fetchData = async () => {
//       // Map tour packages once
//       const tourData = Array.isArray(tourSectorDetails?.tour_package)
//         ? tourSectorDetails.tour_package.map((t) => ({
//             ...t,
//             __type: "tour",
//             priority: t.priority ?? 999,
//           }))
//         : [];

//       let fitData = [];

//       if (activeType === "fit" || activeType === "all") {
//         try {
//           const { data: res } = await axios.get(
//             `${BASE_URL}api/web-tours/web-fit-sectors-package/${id}`
//           );
//           fitData = Array.isArray(res?.tour_package)
//             ? res.tour_package.map((f) => ({
//                 ...f,
//                 __type: "fit",
//                 priority: f.priority ?? 999,
//               }))
//             : [];
//         } catch (err) {
//           console.error("FIT fetch error", err);
//         }
//       }

//       if (cancelled) return;

//       let result;

//       if (activeType === "tour") {
//         result = tourData;
//       } else if (activeType === "fit") {
//         result = fitData;
//       } else {
//         // "all" — merge and sort by priority then created_at
//         result = [...tourData, ...fitData].sort((a, b) => {
//           if (a.priority !== b.priority) return a.priority - b.priority;
//           return new Date(b.created_at) - new Date(a.created_at);
//         });
//       }

//       setTours(result);
//       setFilteredTours(result);
//       setData(result);
//       setHeroThumbnail(result[0]?.thumbnail ?? "");
//       setHero(result[0] ?? {});
//     };

//     fetchData();
//     return () => { cancelled = true; };
//   }, [activeType, id, tourSectorDetails]); // tourSectorDetails ref is stable from parent

//   // -------------------------------------------------------------------------
//   // Reset filters when activeType changes (combined into fetch effect above
//   // would cause double-render; keeping separate is cleaner)
//   // -------------------------------------------------------------------------
//   useEffect(() => {
//     setFilters(INITIAL_FILTERS);
//     setSelectedPriceRange(null);
//   }, [activeType, id]);


//   // -------------------------------------------------------------------------
//   // Filter + sort — memoised so it only recalculates when inputs change
//   // -------------------------------------------------------------------------
//   const applyFiltersAndSort = useCallback(() => {
//     if (!Array.isArray(tours)) return;

//     let result = [...tours];

//     // Price range
//     if (filters.priceRange) {
//       const { min, max } = filters.priceRange;
//       result = result.filter((tour) => {
//         if (tour.__type === "tour") {
//           const price = Number(tour.doubleOccupancy || tour.price);
//           return price >= min && price <= max;
//         }
//         if (tour.__type === "fit") {
//           let lowest = Infinity;
//           tour.forfit?.forEach((f) =>
//             f.seatConfigurationRate?.forEach((r) => {
//               const p = Number(r.price);
//               if (!isNaN(p) && p < lowest) lowest = p;
//             })
//           );
//           return lowest !== Infinity && lowest >= min && lowest <= max;
//         }
//         return false;
//       });
//     }

//     // Duration
//     if (filters.duration) {
//       const { min, max } = filters.duration;
//       result = result.filter((tour) => {
//         const days =
//           tour.__type === "tour"
//             ? tour.duration
//             : tour.tour_itineraries?.length ?? 0;
//         return days >= min && days <= max;
//       });
//     }

//     // Cities
//     if (filters.cities?.length > 0) {
//       result = result.filter((tour) => {
//         const itineraries =
//           tour.__type === "tour"
//             ? [tour.tour_itineraries?.[0]]
//             : tour.tour_itineraries ?? [];

//         const uniqueCities = [
//           ...new Set(
//             itineraries
//               .map((it) => it?.accommodation)
//               .filter((c) => c && c !== "—")
//           ),
//         ];

//         return uniqueCities.some((city) => filters.cities.includes(city));
//       });
//     }

//     // Package types
//     if (filters.packageTypes?.length > 0 && !filters.packageTypes.includes("All")) {
//       result = result.filter((tour) =>
//         tour.categoryList?.some((cat) => filters.packageTypes.includes(cat.name))
//       );
//     }

//     // Sorting
//     switch (sortOption) {
//       case "price-high":
//         result.sort((a, b) => Number(b.price) - Number(a.price));
//         break;
//       case "price-low":
//         result.sort((a, b) => Number(a.price) - Number(b.price));
//         break;
//       case "duration-long":
//         result.sort((a, b) => b.duration - a.duration);
//         break;
//       case "duration-short":
//         result.sort((a, b) => a.duration - b.duration);
//         break;
//       default:
//         break;
//     }

//     setFilteredTours(result);
//   }, [tours, filters, sortOption]);

//   useEffect(() => {
//     applyFiltersAndSort();
//   }, [applyFiltersAndSort, id]);

//   // -------------------------------------------------------------------------
//   // Handlers — stable references via useCallback
//   // -------------------------------------------------------------------------
//   const handleFilterChange = useCallback((filterType, value) => {
//     setFilters((prev) => ({ ...prev, [filterType]: value }));
//   }, []);

//   const clearFilters = useCallback(() => {
//     setFilters(INITIAL_FILTERS);
//     setSelectedPriceRange(null);
//   }, []);

//   const openDrawer = useCallback(() => setFilterDrawerOpen(true), []);
//   const closeDrawer = useCallback(() => setFilterDrawerOpen(false), []);

//   const filterSectionProps = useMemo(() => {
//     const allTours =
//       activeType === "all"
//         ? [...(tourSectorDetails?.tour_package ?? []), ...tours]
//         : tours;

//     const tourDuration =
//       activeType === "all"
//         ? [
//             ...(Array.isArray(tourSectorDetails?.tour_duration)
//               ? tourSectorDetails.tour_duration.flat()
//               : []),
//             ...tours.map((t) => ({ no_days: t.tour_itineraries?.length ?? 0 })),
//           ]
//         : activeType !== "fit"
//         ? tours.map((t) => ({ no_days: t.duration ?? 0 }))
//         : tours.map((t) => ({ no_days: t.tour_itineraries?.length ?? 0 }));

//     const cities = [
//       ...new Set(
//         tours.flatMap((tour) =>
//           (tour.tour_itineraries ?? [])
//             .map((it) =>
//               typeof it?.accommodation === "string"
//                 ? it.accommodation.trim()
//                 : null
//             )
//             .filter((c) => c && c !== "—")
//         )
//       ),
//     ];

//     return {
//       tourSectorDetails: {
//         tour_package: allTours,
//         tour_package_type: tourSectorDetails?.tour_package_type,
//         tour_duration: tourDuration,
//         tour_price: getPriceRangeFromTours(allTours),
//         cities,
//       },
//       filters,
//       onFilterChange: handleFilterChange,
//       onClearFilters: clearFilters,
//       selectedPriceRange,
//       setSelectedPriceRange,
//       activeType,
//       getPriceRangeFromTours,
//     };
//   }, [
//     activeType,
//     tours,
//     tourSectorDetails,
//     filters,
//     handleFilterChange,
//     clearFilters,
//     selectedPriceRange,
//     id,
//   ]);

//   // -------------------------------------------------------------------------
//   // Render
//   // -------------------------------------------------------------------------
//   return (
// <section id="tour-section" className="py-5">
//   <div className="con-tour-section">

//     {/* HEADER */}
//     <div className="mb-3">
//              <h1
//           className="mb-2 section-title"
//           style={{ color: "#0a3b78", fontWeight: "700", fontSize: "42px" }}
//         >
//           {tours?.[0]?.tour_sector_name || ""}
//           Tour Packages
//           <p
//             className="subtitle mb-4 fs-5"
//             style={{ fontSize: "18px", fontWeight: "400" }}
//           >
//             Explore {filteredTours.length} packages for your dream vacation
//           </p>
//         </h1>
//     </div>

//     {/* MOBILE BUTTONS */}
//     <div className="d-flex justify-content-between d-md-none mb-3">
//       <button
//         onClick={openDrawer}
//         className="btn btn-primary"
//         style={{ fontWeight: 600 }}
//       >
//         Filters
//       </button>

//       <button
//         onClick={clearFilters}
//         className="btn btn-outline-secondary"
//         style={{ fontWeight: 600 }}
//       >
//         Clear
//       </button>
//     </div>

//     {/* OFFCANVAS FILTER (MOBILE) */}
//     <Offcanvas
//       show={filterDrawerOpen}
//       onHide={closeDrawer}
//       placement="start"
//       className="w-75"
//     >
//       <Offcanvas.Header
//         closeButton
//         style={{
//           background: "#0a3b78",
//           color: "#fff",
//           paddingTop: "70px",
//         }}
//       >
//         <style>{`.btn-close { filter: invert(1); }`}</style>
//         <Offcanvas.Title>Filters</Offcanvas.Title>
//       </Offcanvas.Header>

//       <Offcanvas.Body
//         className="p-3"
//         style={{ overflowY: "auto" }}
//       >
//         <div style={{ width: "100%" }}>
//           <FilterSection {...filterSectionProps} />
//         </div>
//       </Offcanvas.Body>
//     </Offcanvas>

//     <Row>

//       {/* SIDEBAR FILTER (DESKTOP FIXED) */}
//       <Col lg={2} md={3} className="d-none d-md-block">
//         <div
//           style={{
//             width: "100%",
//             background: "#fff",
//             padding: "10px",
//             borderRadius: "8px",
//           }}
//         >
//           <FilterSection {...filterSectionProps} />
//         </div>
//       </Col>

//       {/* MAIN CONTENT */}
//       <Col lg={10} md={9}>

//         <SortingSection
//           viewMode={viewMode}
//           setViewMode={setViewMode}
//           sortOption={sortOption}
//           setSortOption={setSortOption}
//           activeType={activeType}
//           setActiveType={setActiveType}
//         />

//         {/* TOUR GRID FIX */}
//         <Row
//           className={`${viewMode === "grid" ? "grid-view" : "list-view"} g-3`}
//         >
//           {filteredTours.map((tour) => (
//             <Col
//               key={tour.id}
//               xs={12}
//               sm={6}
//               md={6}
//               lg={viewMode === "grid" ? 3 : 12}
//               className="mb-3"
//             >
//               <TourCard
//                 tour={tour}
//                 viewMode={viewMode}
//                 activeType={activeType}
//               />
//             </Col>
//           ))}
//         </Row>

//       </Col>
//     </Row>
//   </div>
// </section>
//   );
// }

// export default TourPackeges;







import React, { useState, useEffect, useCallback, useMemo } from "react";
import { Row, Col, Offcanvas } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../assets/css/style.css";
import FilterSection from "./FilterSection";
import SortingSection from "./SortingSection";
import TourCard from "./TourCard ";
import BASE_URL from "../../component/commanfile";
import axios from "axios";

// ---------------------------------------------------------------------------
// PRICE RANGE HELPER
// ---------------------------------------------------------------------------
const getPriceRangeFromTours = (tours = []) => {
  if (!Array.isArray(tours) || tours.length === 0) return [];

  const prices = [];

  tours.forEach((tour) => {
    if (tour.__type !== "fit" && tour.doubleOccupancy) {
      const price = Number(tour.doubleOccupancy);
      if (!isNaN(price)) prices.push(price);
    }

    if (tour.__type === "fit" && Array.isArray(tour.forfit)) {
      tour.forfit.forEach((config) => {
        config.seatConfigurationRate?.forEach((rate) => {
          const price = Number(rate.price);
          if (!isNaN(price)) prices.push(price);
        });
      });
    }
  });

  if (prices.length === 0) return [];
  prices.sort((a, b) => a - b);

  const minPrice = prices[0];
  const maxPrice = prices[prices.length - 1];

  if (minPrice === maxPrice) return [{ min: 0, max: maxPrice }];

  const priceRange = maxPrice - minPrice;
  const bucketCount = Math.max(Math.ceil(priceRange / 50000), 3);
  const bucketSize = Math.ceil(priceRange / bucketCount);

  const buckets = [];
  let currentMin = minPrice;

  for (let i = 0; i < bucketCount; i++) {
    const currentMax = Math.min(currentMin + bucketSize, maxPrice);
    buckets.push({ min: currentMin, max: currentMax });
    currentMin = currentMax + 1;
  }

  return buckets;
};

// ---------------------------------------------------------------------------
// INITIAL FILTER STATE
// ---------------------------------------------------------------------------
const INITIAL_FILTERS = {
  priceRange: null,
  duration: null,
  departureDates: null,
  cities: [],
  packageTypes: [],
  specialties: [],
};

// ---------------------------------------------------------------------------
// COMPONENT
// ---------------------------------------------------------------------------
function TourPackeges({
  tourSectorDetails,
  id,
  data,
  setData,
  setHeroThumbnail,
  setHero,
}) {
  const [activeType, setActiveType] = useState("all");

  const [tours, setTours] = useState([]);
  const [filteredTours, setFilteredTours] = useState([]);

  const [viewMode, setViewMode] = useState("grid");
  const [sortOption, setSortOption] = useState("deals");

  const [selectedPriceRange, setSelectedPriceRange] = useState(null);
  const [filterDrawerOpen, setFilterDrawerOpen] = useState(false);
  const [filters, setFilters] = useState(INITIAL_FILTERS);

  // -------------------------------------------------------------------------
  // FETCH DATA
  // -------------------------------------------------------------------------
  useEffect(() => {
    let cancelled = false;

    const fetchData = async () => {
      const tourData = Array.isArray(tourSectorDetails?.tour_package)
        ? tourSectorDetails.tour_package.map((t) => ({
            ...t,
            __type: "tour",
            priority: t.priority ?? 999,
          }))
        : [];

      let fitData = [];

      if (activeType === "fit" || activeType === "all") {
        try {
          const { data: res } = await axios.get(
            `${BASE_URL}api/web-tours/web-fit-sectors-package/${id}`
          );

          fitData = Array.isArray(res?.tour_package)
            ? res.tour_package.map((f) => ({
                ...f,
                __type: "fit",
                priority: f.priority ?? 999,
              }))
            : [];
        } catch (err) {
          console.error("FIT fetch error", err);
        }
      }

      if (cancelled) return;

      let result = [];

      if (activeType === "tour") {
        result = tourData;
      } else if (activeType === "fit") {
        result = fitData;
      } else {
        result = [...tourData, ...fitData].sort((a, b) => {
          if (a.priority !== b.priority) return a.priority - b.priority;
          return new Date(b.created_at) - new Date(a.created_at);
        });
      }

      setTours(result);
      setFilteredTours(result);

      setData(result);
      setHeroThumbnail(result[0]?.thumbnail ?? "");
      setHero(result[0] ?? {});
    };

    fetchData();

    return () => {
      cancelled = true;
    };
  }, [activeType, id, tourSectorDetails]);

  // -------------------------------------------------------------------------
  // RESET FILTERS
  // -------------------------------------------------------------------------
  useEffect(() => {
    setFilters(INITIAL_FILTERS);
    setSelectedPriceRange(null);
  }, [activeType]);

  // -------------------------------------------------------------------------
  // APPLY FILTERS + SORT
  // -------------------------------------------------------------------------
  const applyFiltersAndSort = useCallback(() => {
    let result = [...tours];

    // PRICE FILTER
    if (filters.priceRange) {
      const { min, max } = filters.priceRange;

      result = result.filter((tour) => {
        if (tour.__type === "tour") {
          const price = Number(tour.doubleOccupancy || tour.price);
          return price >= min && price <= max;
        }

        if (tour.__type === "fit") {
          let lowest = Infinity;

          tour.forfit?.forEach((f) =>
            f.seatConfigurationRate?.forEach((r) => {
              const p = Number(r.price);
              if (!isNaN(p) && p < lowest) lowest = p;
            })
          );

          return lowest !== Infinity && lowest >= min && lowest <= max;
        }

        return false;
      });
    }

    // DURATION FILTER
    if (filters.duration) {
      const { min, max } = filters.duration;

      result = result.filter((tour) => {
        const days =
          tour.__type === "tour"
            ? tour.duration
            : tour.tour_itineraries?.length ?? 0;

        return days >= min && days <= max;
      });
    }

    // CITIES FILTER
    if (filters.cities?.length) {
      result = result.filter((tour) => {
        const cities =
          tour.tour_itineraries?.map((it) => it?.accommodation) ?? [];

        return cities.some((c) => filters.cities.includes(c));
      });
    }

    // PACKAGE TYPES
    if (
      filters.packageTypes?.length &&
      !filters.packageTypes.includes("All")
    ) {
      result = result.filter((tour) =>
        tour.categoryList?.some((cat) =>
          filters.packageTypes.includes(cat.name)
        )
      );
    }

    // SORTING
    switch (sortOption) {
      case "price-high":
        result.sort((a, b) => Number(b.price) - Number(a.price));
        break;
      case "price-low":
        result.sort((a, b) => Number(a.price) - Number(b.price));
        break;
      case "duration-long":
        result.sort((a, b) => b.duration - a.duration);
        break;
      case "duration-short":
        result.sort((a, b) => a.duration - b.duration);
        break;
      default:
        break;
    }

    setFilteredTours(result);
  }, [tours, filters, sortOption]);

  useEffect(() => {
    applyFiltersAndSort();
  }, [applyFiltersAndSort]);

  useEffect(() => {
   setActiveType("all");
  } , [id]);

  // -------------------------------------------------------------------------
  // HANDLERS
  // -------------------------------------------------------------------------
  const handleFilterChange = useCallback((type, value) => {
    setFilters((prev) => ({ ...prev, [type]: value }));
  }, []);

  const clearFilters = useCallback(() => {
    setFilters(INITIAL_FILTERS);
    setSelectedPriceRange(null);
  }, []);

  const openDrawer = useCallback(() => setFilterDrawerOpen(true), []);
  const closeDrawer = useCallback(() => setFilterDrawerOpen(false), []);

  // -------------------------------------------------------------------------
  // FILTER SECTION DATA (FIXED - ONLY USE tours)
  // -------------------------------------------------------------------------
  const filterSectionProps = useMemo(() => {
    const sourceTours = tours;

    const tourDuration = sourceTours.map((t) => ({
      no_days:
        t.__type === "tour"
          ? t.duration ?? 0
          : t.tour_itineraries?.length ?? 0,
    }));

    const cities = [
      ...new Set(
        sourceTours.flatMap((tour) =>
          (tour.tour_itineraries ?? [])
            .map((it) => it?.accommodation?.trim())
            .filter(Boolean)
        )
      ),
    ];
const packageTypes = [
  ...new Map(
    sourceTours
      .flatMap((t) =>
        (t.categoryList ?? []).map((c) => ({
          id: c.id, 
          name: c.name,
        }))
      )
      .filter((c) => c.id && c.name)
      .map((item) => [item.id, item])
  ).values(),
];

console.log("sourceTours---",packageTypes)
    return {
      tourSectorDetails: {
        tour_package: sourceTours,
tour_package_type: packageTypes,
        tour_duration: tourDuration,
        tour_price: getPriceRangeFromTours(sourceTours),
        cities,
      },
      filters,
      onFilterChange: handleFilterChange,
      onClearFilters: clearFilters,
      selectedPriceRange,
      setSelectedPriceRange,
      activeType,
      getPriceRangeFromTours
    };
  }, [tours, filters, selectedPriceRange, activeType]);

  // -------------------------------------------------------------------------
  // UI
  // -------------------------------------------------------------------------
  return (
    <section id="tour-section" className="py-5">
      <div className="con-tour-section">

        <div className="mb-3">
             <h1
          className="mb-2 section-title"
          style={{ color: "#0a3b78", fontWeight: "700", fontSize: "42px" }}
        >
          {tours?.[0]?.tour_sector_name || ""}
          Tour Packages
          <p
            className="subtitle mb-4 fs-5"
            style={{ fontSize: "18px", fontWeight: "400" }}
          >
            Explore {filteredTours.length} packages for your dream vacation
          </p>
          </h1>
        </div>

    {/* MOBILE BUTTONS */}
    <div className="d-flex justify-content-between d-md-none mb-3">
      <button
        onClick={openDrawer}
        className="btn btn-primary"
        style={{ fontWeight: 600 }}
      >
        Filters
      </button>

      <button
        onClick={clearFilters}
        className="btn btn-outline-secondary"
        style={{ fontWeight: 600 }}
      >
        Clear
      </button>
    </div>

    {/* OFFCANVAS FILTER (MOBILE) */}
    <Offcanvas
      show={filterDrawerOpen}
      onHide={closeDrawer}
      placement="start"
      className="w-75"
    >
      <Offcanvas.Header
        closeButton
        style={{
          background: "#0a3b78",
          color: "#fff",
          paddingTop: "70px",
        }}
      >
        <style>{`.btn-close { filter: invert(1); }`}</style>
        <Offcanvas.Title>Filters</Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body
        className="p-3"
        style={{ overflowY: "auto" }}
      >
        <div style={{ width: "100%" }}>
          <FilterSection {...filterSectionProps} />
        </div>
      </Offcanvas.Body>
    </Offcanvas>

        <Row>

          {/* FILTER */}
          <Col lg={2} md={3} className="d-none d-md-block">
            <FilterSection {...filterSectionProps} />
          </Col>

          {/* CONTENT */}
          <Col lg={10} md={9}>
            <SortingSection
              viewMode={viewMode}
              setViewMode={setViewMode}
              sortOption={sortOption}
              setSortOption={setSortOption}
              activeType={activeType}
              setActiveType={setActiveType}
            />

            <Row className={viewMode === "grid" ? "grid-view g-3" : "g-3"}>
              {filteredTours.map((tour) => (
                <Col
                  key={tour.id}
                  xs={12}
                  sm={6}
                  lg={viewMode === "grid" ? 3 : 12}
                >
                  <TourCard
                    tour={tour}
                    viewMode={viewMode}
                    activeType={activeType}
                  />
                </Col>
              ))}
            </Row>
          </Col>

        </Row>
      </div>
    </section>
  );
}

export default TourPackeges;